














































































































































































































































































import _ from "lodash";
import axios, { AxiosResponse } from "axios";
import Fact, { FactTypes, FactRecordHolder } from "@/models/Fact";
import AccuracyDatePicker from "./AccuracyDatePicker.vue";
import CountrySelect from "./CountrySelect.vue";
import MasterFactAssociation from "./MasterFactAssociation.vue";
import EventAssociation from "./EventAssociation.vue";
import HouseholdSize from "./HouseholdSize.vue";
import GeoLocation from "./GeoLocation.vue";
import { Vue, Component, Watch, Prop } from "vue-property-decorator";

@Component({
  components: {
    AccuracyDatePicker,
    EventAssociation,
    MasterFactAssociation,
    CountrySelect,
    HouseholdSize,
    GeoLocation,
  },
})
export default class FactQuickForm extends Vue {
  @Prop({ type: Object }) value!: FactRecordHolder;
  @Prop({ type: Boolean }) loading!: boolean;

  private formValid: boolean = false;

  get rules() {
    return {
      name: [
        (v: any) => !!v || "Name is required",
        (v: any) =>
          (v && v.length > 10) || "Name must be more than 10 characters",
      ],
      country: [(v: any) => !!v || "Country is required"],
      year: [(v: any) => !!v || "Year is required"],
      displacement_type: [(v: any) => !!v || "Displacement type is required"],
      fact_type: [(v: any) => !!v || "Fact type is required"],
      figure: [
        (value: any) => !!value || "Figure is required",
        (value: any) =>
          (value && Number.isInteger(value)) || "Whole numbers only",
      ],
      stock_date: [
        (v: any) => {
          if (_.includes(this.value.data.type, "Stock") && !v) {
            return "Stock date is required";
          } else {
            return true;
          }
        },
      ],
      start_date: [
        (v: any) => {
          if (_.includes(this.value.data.type, "Flow") && !v) {
            return "Start date is required";
          } else {
            return true;
          }
        },
      ],
      end_date: [
        (v: any) => {
          if (
            _.includes(this.value.data.type, "Flow") &&
            !!this.value.data.data.start_date.date &&
            !!v &&
            this.value.data.data.start_date.date > v
          ) {
            return "Can't be less that start date";
          } else {
            return true;
          }
        },
      ],
    };
  }

  get factTypes() {
    return FactTypes;
  }

  // Returns a list of years starting from the current year
  // used to fillup the select field
  get years() {
    const currYear = new Date().getFullYear();
    return _.range(currYear, 1950, -1);
  }

  // Returns true if the fact is a flow type
  // used to determine the type of date fields
  get isFlow(): boolean {
    // @ts-ignore
    return _.includes(this.value.data.type, "Flow");
  }

  validateForm() {
    // @ts-ignore
    if (this.$refs.form.validate()) {
      this.$toast.success("OK!");
    }
  }

  async saveFact() {
    // TODO check form validity
    this.$emit("loadingFact", true);
    let payload = { ...this.value.data };
    try {
      let response: AxiosResponse;
      if (this.value.parkingLot) {
        // save fact from parking lot
        delete payload.id;
        response = await this.saveFactRPC(payload, this.value.id);
      } else if (!payload.id) {
        // save new fact
        delete payload.id;
        response = await this.saveFactRPC(payload, null);
      } else {
        // save fact
        response = await this.saveFactRPC(payload, null);
      }
      this.$toast.success("Fact is saved");
      this.$emit("updateTables");
      this.value.parkingLot = false;
      this.value.data = response.data;
      // let { id } = response.data;
      // this.$router.push(`/scaffold/facts/${id}`);
    } catch (error) {
      console.error(error);
      console.error(error.response);
      this.$toast.error("Failed to save the fact");
    }
    console.dir(this.value);
    this.$emit("loadingFact", false);
  }

  async saveFactRPC(payload: any, parking_lot_id: number | null) {
    return axios.post(
      "/psql/rpc/helix_save_fact",
      { payload, parking_lot_id },
      {
        headers: { Accept: "application/vnd.pgrst.object+json" },
      }
    );
  }

  setHouseholdSize(value: any) {
    this.value.data.household_size = value;
    this.calculate();
  }

  calculate() {
    if (!!this.value.data) {
      if (this.value.data.data.unit === "Household") {
        this.value.data.data.figure = Math.round(
          this.value.data.data.reported_figure *
            this.value.data.household_size.figure
        );
      } else {
        this.value.data.data.figure = this.value.data.data.reported_figure;
      }
    }
  }
}
